module.exports = __webpack_public_path__ + "media/images/top/reserved_order-e8a01052ae6028d470f302b6cc399eb2.png";